module.exports = __webpack_public_path__ + "media/images/pic/saska/saska_adults-01b424790c939a9ea2fa6a857323da3c.png";